import { Icons } from '@commenda/kakashi';
import { SysEmailRecipientMode, WorkflowStepType } from '@commenda/types';
import { ServiceAuditorEditorHelper } from '../../workflow-editor/helpers/ServiceAuditorEditorHelper';
import { TNodeTemplate } from '../../workflow-editor/types/node';

export class WorkflowNodeHelper {
  static nodeTemplates: Record<WorkflowStepType, TNodeTemplate> = {
    [WorkflowStepType.START]: {
      label: 'Start',
      icon: <Icons.Play className="size-4" />,
      bgClassName: 'bg-bg-success-hover',
      stepType: WorkflowStepType.START,

      defaultData: {
        type: WorkflowStepType.START,
        name: 'Start',
      },
    },
    [WorkflowStepType.END]: {
      label: 'End',
      icon: <Icons.Stop className="size-4" />,
      bgClassName: 'bg-bg-success-hover',
      stepType: WorkflowStepType.END,
      defaultData: {
        type: WorkflowStepType.END,
        name: 'End',
      },
    },
    [WorkflowStepType.HUMAN_CONFIRM]: {
      label: 'Human confirmation',
      icon: <Icons.CheckCircle className="size-4" />,
      bgClassName: 'bg-bg-info-hover',
      stepType: WorkflowStepType.HUMAN_CONFIRM,
      defaultData: {
        type: WorkflowStepType.HUMAN_CONFIRM,
        name: 'Human confirmation',
      },
    },
    [WorkflowStepType.HUMAN_FORM]: {
      label: 'Human form',
      icon: <Icons.File05 className="size-4" />,
      bgClassName: 'bg-bg-info-hover',
      stepType: WorkflowStepType.HUMAN_FORM,
      defaultData: {
        type: WorkflowStepType.HUMAN_FORM,
        name: 'Human form',
      },
    },
    [WorkflowStepType.HUMAN_REDIRECT]: {
      label: 'Human redirect',
      icon: <Icons.ArrowUpRight className="size-4" />,
      bgClassName: 'bg-bg-info-hover',
      stepType: WorkflowStepType.HUMAN_REDIRECT,
      defaultData: {
        type: WorkflowStepType.HUMAN_REDIRECT,
        name: 'Human redirect',
      },
    },
    [WorkflowStepType.HUMAN_ESIGN]: {
      label: 'E-signature',
      icon: <Icons.Edit04 className="size-4" />,
      bgClassName: 'bg-bg-info-hover',
      stepType: WorkflowStepType.HUMAN_ESIGN,
      defaultData: {
        type: WorkflowStepType.HUMAN_ESIGN,
        name: 'E-signature',
      },
    },
    [WorkflowStepType.GATEWAY_PARALLEL_SPLIT]: {
      label: 'Run steps in parallel',
      icon: <Icons.GitBranch01 className="size-3.5" />,
      bgClassName: 'bg-bg-warning-hover',
      stepType: WorkflowStepType.GATEWAY_PARALLEL_SPLIT,
      defaultData: {
        type: WorkflowStepType.GATEWAY_PARALLEL_SPLIT,
        name: 'Run steps in parallel',
      },
    },
    [WorkflowStepType.GATEWAY_PARALLEL_JOIN]: {
      label: 'Merge steps',
      icon: <Icons.GitMerge className="size-3.5" />,
      bgClassName: 'bg-bg-warning-hover',
      stepType: WorkflowStepType.GATEWAY_PARALLEL_JOIN,
      defaultData: {
        type: WorkflowStepType.GATEWAY_PARALLEL_JOIN,
        name: 'Merge steps',
      },
    },
    [WorkflowStepType.GATEWAY_BOOLEAN_EXCLUSIVE_SPLIT]: {
      label: 'If else',
      icon: <Icons.ArrowNarrowRight className="size-3.5" />,
      bgClassName: 'bg-bg-warning-hover',
      stepType: WorkflowStepType.GATEWAY_BOOLEAN_EXCLUSIVE_SPLIT,
      defaultData: {
        type: WorkflowStepType.GATEWAY_BOOLEAN_EXCLUSIVE_SPLIT,
        name: 'If else',
      },
    },
    [WorkflowStepType.GATEWAY_INCLUSIVE_SPLIT]: {
      label: 'Inclusive split',
      icon: <Icons.ArrowsRight className="size-3.5" />,
      bgClassName: 'bg-bg-warning-hover',
      stepType: WorkflowStepType.GATEWAY_INCLUSIVE_SPLIT,
      defaultData: {
        type: WorkflowStepType.GATEWAY_INCLUSIVE_SPLIT,
        name: 'Inclusive split',
      },
    },
    [WorkflowStepType.SYS_SUB_WORKFLOW]: {
      label: 'Sub-workflow',
      icon: <Icons.Link01 className="size-3.5" />,
      bgClassName: 'bg-bg-gray-hover',
      stepType: WorkflowStepType.SYS_SUB_WORKFLOW,
      defaultData: {
        type: WorkflowStepType.SYS_SUB_WORKFLOW,
        name: 'Sub-workflow',
      },
    },
    // DEMO ONLY - Do not use in production
    [WorkflowStepType.SYS_LLM]: {
      label: 'LLM (demo only)',
      icon: <Icons.MessageChatCircle className="size-3.5" />,
      bgClassName: 'bg-bg-gray-hover',
      stepType: WorkflowStepType.SYS_LLM,
      defaultData: {
        type: WorkflowStepType.SYS_LLM,
        name: 'LLM',
      },
    },
    // DEMO ONLY - Do not use in production
    [WorkflowStepType.DEMO_AI_FILLING_AGENT]: {
      label: 'AI filling agent (demo only)',
      icon: <Icons.Stars02 className="size-3.5" />,
      bgClassName: 'bg-bg-gray-hover',
      stepType: WorkflowStepType.DEMO_AI_FILLING_AGENT,
      defaultData: {
        type: WorkflowStepType.DEMO_AI_FILLING_AGENT,
        name: 'AI filling agent',
      },
    },
    [WorkflowStepType.SYS_TOOL_CALL]: {
      label: 'Tool call',
      icon: <Icons.Tool01 className="size-3.5" />,
      bgClassName: 'bg-bg-gray-hover',
      stepType: WorkflowStepType.SYS_TOOL_CALL,
      defaultData: {
        type: WorkflowStepType.SYS_TOOL_CALL,
        name: 'Tool call',
      },
    },
    // DEMO ONLY - Do not use in production
    [WorkflowStepType.DEMO_EMAIL]: {
      label: 'Email (demo only)',
      icon: <Icons.Mail01 className="size-3.5" />,
      bgClassName: 'bg-bg-gray-hover',
      stepType: WorkflowStepType.DEMO_EMAIL,
      defaultData: {
        type: WorkflowStepType.DEMO_EMAIL,
        name: 'Email',
      },
    },
    // DEMO ONLY - Do not use in production
    [WorkflowStepType.HUMAN_REVIEW]: {
      label: 'Human review (demo only)',
      icon: <Icons.Eye className="size-4" />,
      bgClassName: 'bg-bg-info-hover',
      stepType: WorkflowStepType.HUMAN_REVIEW,
      defaultData: {
        type: WorkflowStepType.HUMAN_REVIEW,
        name: 'Human review',
      },
    },
    [WorkflowStepType.SYS_API_CALL]: {
      label: 'API call (only internal use)',
      icon: <Icons.Globe01 className="size-3.5" />,
      bgClassName: 'bg-bg-gray-hover',
      stepType: WorkflowStepType.SYS_API_CALL,
      defaultData: {
        type: WorkflowStepType.SYS_API_CALL,
        name: 'API call',
      },
    },
    [WorkflowStepType.SYS_ROOTFI_SYNC]: {
      label: 'Integrations',
      icon: <Icons.Database01 className="size-3.5" />,
      bgClassName: 'bg-bg-gray-hover',
      stepType: WorkflowStepType.SYS_ROOTFI_SYNC,
      defaultData: {
        type: WorkflowStepType.SYS_ROOTFI_SYNC,
        name: 'Integrations',
      },
    },
    [WorkflowStepType.SYS_EMAIL]: {
      label: 'Send email',
      icon: <Icons.Mail01 className="size-3.5" />,
      bgClassName: 'bg-bg-gray-hover',
      stepType: WorkflowStepType.SYS_EMAIL,
      defaultData: {
        type: WorkflowStepType.SYS_EMAIL,
        name: 'Send email',
        recipientMode: SysEmailRecipientMode.MATTER_THREAD,
      },
    },
    [WorkflowStepType.SYS_AI_AGENT]: {
      label: 'Agent',
      icon: <Icons.Stars02 className="size-3.5" />,
      bgClassName: 'bg-bg-gray-hover',
      stepType: WorkflowStepType.SYS_AI_AGENT,
      defaultData: {
        type: WorkflowStepType.SYS_AI_AGENT,
        name: 'Agent',
      },
    },
    [WorkflowStepType.SYS_WATCH_JOB]: {
      label: 'Watch job',
      icon: <Icons.ClockRefresh className="size-3.5" />,
      bgClassName: 'bg-bg-gray-hover',
      stepType: WorkflowStepType.SYS_WATCH_JOB,
      defaultData: {
        type: WorkflowStepType.SYS_WATCH_JOB,
        name: 'Watch job',
      },
    },
  };

  // A palette preset, not a step type: dropping it inserts the auditor and its approval step.
  static readonly draftAuditorTemplate: TNodeTemplate = {
    label: 'Draft auditor',
    icon: <Icons.FileCheck02 className="size-3.5" />,
    bgClassName: 'bg-bg-gray-hover',
    stepType: WorkflowStepType.SYS_AI_AGENT,
    defaultData: {
      type: WorkflowStepType.SYS_AI_AGENT,
      name: ServiceAuditorEditorHelper.AGENT_STEP_NAME,
    },
  };

  static getNodeIcon(type: WorkflowStepType): React.ReactNode {
    return this.nodeTemplates[type].icon || '❓';
  }

  static getNodeLabel(type: WorkflowStepType): string {
    return this.nodeTemplates[type].label || 'Unknown';
  }

  static getHumanNodeTemplates(): TNodeTemplate[] {
    return Object.values(this.nodeTemplates).filter((node) =>
      node.stepType.startsWith('human.')
    );
  }

  static getGatewayNodeTemplates(): TNodeTemplate[] {
    return Object.values(this.nodeTemplates).filter((node) =>
      node.stepType.startsWith('gateway.')
    );
  }

  static getSystemNodeTemplates(): TNodeTemplate[] {
    return Object.values(this.nodeTemplates).filter(
      (node) =>
        node.stepType.startsWith('sys.') &&
        node.stepType !== WorkflowStepType.SYS_LLM
    );
  }

  static isGatewayNode(type: WorkflowStepType): boolean {
    return type.startsWith('gateway.');
  }

  static isSystemNode(type: WorkflowStepType): boolean {
    return type.startsWith('sys.');
  }

  static isHumanNode(type: WorkflowStepType): boolean {
    return type.startsWith('human.') && type !== WorkflowStepType.HUMAN_REVIEW;
  }
}
